// extracted by mini-css-extract-plugin
export var clauseRow = "_bg-6";
export var emptyState = "_bg-d";
export var filterContent = "_bg-a";
export var filterGroup = "_bg-1";
export var filterGroupContainer = "_bg-0";
export var nestedGroup = "_bg-2";
export var nestedGroupContent = "_bg-b";
export var nestedGroupDepth1 = "_bg-3";
export var nestedGroupDepth2 = "_bg-4";
export var nestedGroupDepth3 = "_bg-5";
export var nestedGroupEmpty = "_bg-c";
export var operatorAnd = "_bg-8";
export var operatorOr = "_bg-9";
export var operatorToggle = "_bg-7";
export var removeGroupButton = "_bg-e";